import script from "./TabFieldImage.vue?vue&type=script&setup=true&lang=js"
export * from "./TabFieldImage.vue?vue&type=script&setup=true&lang=js"

import "./TabFieldImage.vue?vue&type=style&index=0&id=45b73b4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45b73b4c"]])

export default __exports__